'use client';

import { useState, useEffect } from 'react';
import AppImage from '@/components/ui/AppImage';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center px-6 lg:px-12 py-24 lg:py-32">
      <div className="max-w-7xl w-full grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Text Content */}
        <div
          className={`space-y-8 transition-all duration-slow ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`
          }>

          <div className="space-y-4">
            <p className="text-sm font-cta font-semibold tracking-[0.2em] text-muted-foreground uppercase">
              About Valinaire
            </p>
            <h1 className="text-5xl lg:text-7xl font-headline font-bold leading-[1.1] text-primary">
              From Finance to Digital Growth
            </h1>
          </div>
          
          <div className="space-y-6 text-lg lg:text-xl font-body text-text-secondary leading-relaxed">
            <p>Valinaire is a Raleigh-based digital services company dedicated to helping local and online businesses grow with confidence.

            </p>
            <p>Founded by a former financial analyst with an economics degree from UNC Chapel Hill, Valinaire blends data-driven strategy with creative execution to deliver real results. Since 2020, we’ve helped brands strengthen their social media presence, launch effective paid marketing campaigns, streamline operations through automation, and build modern, conversion-focused websites.

            </p>
            <p>With a friendly, hands-on approach and a deep understanding of the Triangle market, Valinaire partners closely with businesses to create sustainable, long-term growth.

            </p>
          </div>

          <div className="pt-4">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-primary text-primary-foreground text-sm font-cta font-semibold tracking-wide border border-primary transition-all duration-fast hover:-translate-y-0.5 cursor-pointer">

              Work With Valinaire
            </a>
          </div>
        </div>

        {/* Portrait Image */}
        <div
          className={`relative transition-all duration-slow delay-300 ${
          isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`
          }>

          <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted">
            <AppImage
              src="/assets/images/Kero_Final_Headshot-1775839899087.jpg"
              alt="Professional portrait representing Valinaire's founder and digital growth expertise"
              className="w-full h-full object-cover grayscale brightness-90 contrast-110 transition-all duration-medium" />

            
            {/* Decorative Border */}
            <div className="absolute inset-0 border-2 border-primary opacity-0 hover:opacity-100 transition-opacity duration-fast pointer-events-none" />
          </div>

          {/* Floating Stats */}
          <div className="absolute -bottom-8 -left-8 bg-secondary border border-border p-8 shadow-card">
            <div className="text-5xl font-headline font-bold text-primary">6+</div>
            <div className="text-sm font-cta font-semibold tracking-wide text-muted-foreground mt-2">
              Years Experience
            </div>
          </div>

          <div className="absolute -top-8 -right-8 bg-secondary border border-border p-8 shadow-card">
            <div className="text-5xl font-headline font-bold text-primary">100+</div>
            <div className="text-sm font-cta font-semibold tracking-wide text-muted-foreground mt-2">
              Projects Delivered
            </div>
          </div>
        </div>
      </div>
    </section>);

}